<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Bill No：{{ formData.shipmentExpenseNo || 'New' }}
        </span>
        <el-divider
          direction="vertical"
          v-if="formData.shipmentExpenseStatus"
        ></el-divider>
        <b-badge
          v-if="formData.shipmentExpenseStatus"
          style="font-size: 12px"
          :variant="
            formData.shipmentExpenseStatus === 'Y'
              ? 'success'
              : formData.shipmentExpenseStatus === 'S'
              ? 'warning'
              : formData.shipmentExpenseStatus === 'D' ||
                formData.shipmentExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_shipmentExpenseStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDateEndOpt"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_payeeType') || '收款方'"
            prop="payeeType"
          >
            <dict-select
              v-model="formData.payeeType"
              url="/master/common/dict/biz"
              :body="payeeTypeParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
              @change="payeeTypeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10" v-if="formData.payeeType == 'S'">
          <el-form-item
            :label="$l('form_label_PayeeScm') || '收款供应商'"
            prop="payeeScmCode"
          >
            <dict-select
              v-model="formData.payeeScmCode"
              url="/master/common/dict/allScmCooperated"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              size="mini"
              @change="payeeScmChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10" v-if="formData.payeeType === 'C'">
          <el-form-item
            :label="$l('form_label_payeeCustomer') || '收款客户'"
            prop="payeeScmCode"
          >
            <dict-select
              v-model="formData.payeeScmCode"
              url="/digitalCenter/common/dict/customer"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              size="mini"
              @change="payeeScmChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="$l('form_label_payeeScmBankName') || '收款方开户银行'"
            prop="bankName"
          >
            <el-input v-model="formData.bankName" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePayScmBank"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('form_label_payeeScmBankAccountName') || '收款方账户名称'
            "
          >
            <el-input v-model="formData.bankAccountName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payeeScmBankAccountNo') || '收款方银行账号'"
          >
            <el-input v-model="formData.bankAccountNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('form_label_payeeScmBankAccountType') || '收款方银行账户性质'
            "
          >
            <el-input v-model="formData.v_bankAccountType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('form_label_payeeScmBankAccountKind') || '收款方银行账号类别'
            "
          >
            <el-input v-model="formData.v_bankAccountKind" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_expensePayer') || '费用付款方'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              :selectedLabel.sync="formData.expensePayerName"
              url="/master/common/dict/biz"
              :body="expensePayerParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_remark') || '付款用途'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
               type="textarea"
              :rows="2"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_description') || '说明（不参与打印）'"
            prop="description"
          >
            <el-input
              v-model="formData.description"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="2"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :shipmentExpenseCode="shipmentExpenseCode"
          :disabled="disabled"
          :tableData="formData.listItem"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          @addDoc="(e) => $refs.docTable.addDoc(e)"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :tableData="formData.listDoc"
        />
      </el-row>
    </el-form>
    <ChooseBank
      :visible.sync="chooseScmBankVisible"
      :title="$l('dialog_title_choose_payeeScmBank') || '选择收款方银行信息'"
      @confirm="updateBanInfo"
      :selectApi="selectBankApi"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import dayjs from 'dayjs'
import ChooseBank from '../choose-bank'
export default {
  components: { ItemTable, DocTable, ChooseBank },
  mixins: [EditLoading],
  props: {
    shipmentExpenseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      chooseScmBankVisible: false,
      expensePayerParams: { dictType: 'expensePayer' },
      payeeTypeParams: { dictType: 'payeeType' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      requestDateEndOpt: this.requestDateEnd(),
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        payeeType: 'S',
        currencyAmount: 0,
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        paymentMethod: '5', // 5-网银
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        paymentMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        bankName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        description: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      selectBankApi: () => [],
    }
  },
  computed: {
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.shipmentExpenseCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    // 申请日期限制
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    getData() {
      if (!this.shipmentExpenseCode) return
      this.$api
        .shipmentExpenseDetailApi({
          shipmentExpenseCode: this.shipmentExpenseCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      const listDoc = this.$refs.docTable.getTableData()

      this.loadingOpen()
      const params = { ...this.formData, listItem, listDoc }
      const res = await this.$api
        .shipmentExpenseSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.shipmentExpenseCode) {
        this.closeCurPage()
      } else {
        this.getData()
      }
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    payeeTypeChange() {
      this.updateBanInfo({})
    },
    async payeeScmChange(code) {
      const payeeType = this.formData.payeeType
      const listBank =
        payeeType == 'C'
          ? await this.getCustData({ custCode: code })
          : await this.getScmData({ scmCode: code })
      const bankData = !listBank || listBank.length > 1 ? {} : listBank[0] || {}
      this.updateBanInfo(bankData)
    },
    async getCustData(form) {
      return await this.$api
        .masterCustomerBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    async getScmData(form) {
      return await this.$api
        .masterScmInfoBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    openChoosePayScmBank() {
      const { payeeScmCode, payeeCustCode } = this.formData
      if (!payeeScmCode && !payeeCustCode) {
        this.$message({
          message: '请先选择收款客户或收款供应商',
          type: 'warning',
        })
        return
      }

      const { payeeType } = this.formData
      if (payeeType === 'C') {
        this.selectBankApi = (form) =>
          this.getCustData({ ...form, custCode: this.formData.payeeScmCode })
      } else {
        this.selectBankApi = (form) =>
          this.getScmData({ ...form, scmCode: this.formData.payeeScmCode })
      }

      this.chooseScmBankVisible = true
    },
    updateBanInfo(e) {
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = e || {}
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
